import React, { useState } from 'react';
import {
  Box,
  Grid,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography
} from '@mui/material';
import { 
  FilterList as FilterIcon,
  ExpandMore as ExpandMoreIcon,
  Search as SearchIcon
} from '@mui/icons-material';
import { 
  PAYMENT_STATUSES, 
  DELIVERY_STATUSES, 
  SALE_SOURCES, 
  DEPOSIT_STATUSES 
} from '../../constants/salesConstants';

const SalesFilters = ({ filters, onFilterChange, employees, isAdmin }) => {
  const [expanded, setExpanded] = useState(false);

  const handleFilterChange = (event) => {
    const { name, value } = event.target;
    onFilterChange({
      ...filters,
      [name]: value
    });
  };

  const handleResetFilters = () => {
    onFilterChange({
      search: '',
      employee: 'all',
      paymentStatus: 'all',
      deliveryStatus: 'all',
      source: 'all',
      depositStatus: 'all',
      dateFrom: '',
      dateTo: '',
      client: 'all'
    });
  };

  return (
    <Accordion 
      expanded={expanded} 
      onChange={() => setExpanded(!expanded)}
      sx={{ mb: 3 }}
    >
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <FilterIcon sx={{ mr: 1 }} />
          <Typography>Filtry i wyszukiwanie</Typography>
        </Box>
      </AccordionSummary>
      <AccordionDetails>
        <Grid container spacing={2}>
          {/* Wyszukiwanie */}
          <Grid item xs={12} md={3}>
            <TextField
              fullWidth
              size="small"
              name="search"
              label="Wyszukaj"
              value={filters.search}
              onChange={handleFilterChange}
              InputProps={{
                startAdornment: <SearchIcon sx={{ mr: 1, color: 'text.secondary' }} />
              }}
              placeholder="Nr faktury, notatki..."
            />
          </Grid>

          {/* Filtr pracownika (tylko dla admina) */}
          {isAdmin && (
            <Grid item xs={12} md={3}>
              <FormControl fullWidth size="small">
                <InputLabel>Sprzedawca</InputLabel>
                <Select
                  name="employee"
                  value={filters.employee}
                  onChange={handleFilterChange}
                  label="Sprzedawca"
                >
                  <MenuItem value="all">Wszyscy sprzedawcy</MenuItem>
                  {employees.map(employee => (
                    <MenuItem key={employee.id} value={employee.id}>
                      {`${employee.firstName || ''} ${employee.lastName || ''}`.trim() || employee.id}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
          )}

          {/* Filtr statusu płatności */}
          <Grid item xs={12} md={3}>
            <FormControl fullWidth size="small">
              <InputLabel>Status płatności</InputLabel>
              <Select
                name="paymentStatus"
                value={filters.paymentStatus}
                onChange={handleFilterChange}
                label="Status płatności"
              >
                <MenuItem value="all">Wszystkie statusy</MenuItem>
                {Object.entries(PAYMENT_STATUSES).map(([key, value]) => (
                  <MenuItem key={key} value={key}>{value}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>

          {/* Filtr statusu dostawy */}
          <Grid item xs={12} md={3}>
            <FormControl fullWidth size="small">
              <InputLabel>Status dostawy</InputLabel>
              <Select
                name="deliveryStatus"
                value={filters.deliveryStatus}
                onChange={handleFilterChange}
                label="Status dostawy"
              >
                <MenuItem value="all">Wszystkie statusy</MenuItem>
                {Object.entries(DELIVERY_STATUSES).map(([key, value]) => (
                  <MenuItem key={key} value={key}>{value}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>

          {/* Filtr źródła sprzedaży */}
          <Grid item xs={12} md={3}>
            <FormControl fullWidth size="small">
              <InputLabel>Źródło</InputLabel>
              <Select
                name="source"
                value={filters.source}
                onChange={handleFilterChange}
                label="Źródło"
              >
                <MenuItem value="all">Wszystkie źródła</MenuItem>
                {Object.entries(SALE_SOURCES).map(([key, value]) => (
                  <MenuItem key={key} value={key}>{value}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>

          {/* Filtr statusu zadatku */}
          <Grid item xs={12} md={3}>
            <FormControl fullWidth size="small">
              <InputLabel>Status zadatku</InputLabel>
              <Select
                name="depositStatus"
                value={filters.depositStatus}
                onChange={handleFilterChange}
                label="Status zadatku"
              >
                <MenuItem value="all">Wszystkie statusy</MenuItem>
                <MenuItem value="has_deposit">Posiada zadatek</MenuItem>
                <MenuItem value="no_deposit">Bez zadatku</MenuItem>
                {Object.entries(DEPOSIT_STATUSES).map(([key, value]) => (
                  <MenuItem key={key} value={key}>{value}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>

          {/* Filtr zakresu dat */}
          <Grid item xs={12} md={3}>
            <TextField
              fullWidth
              size="small"
              name="dateFrom"
              label="Data od"
              type="date"
              value={filters.dateFrom}
              onChange={handleFilterChange}
              InputLabelProps={{ shrink: true }}
            />
          </Grid>

          <Grid item xs={12} md={3}>
            <TextField
              fullWidth
              size="small"
              name="dateTo"
              label="Data do"
              type="date"
              value={filters.dateTo}
              onChange={handleFilterChange}
              InputLabelProps={{ shrink: true }}
            />
          </Grid>

          {/* Przycisk resetowania filtrów */}
          <Grid item xs={12} md={3}>
            <Button 
              variant="outlined" 
              onClick={handleResetFilters}
              fullWidth
            >
              Resetuj filtry
            </Button>
          </Grid>
        </Grid>
      </AccordionDetails>
    </Accordion>
  );
};

export default SalesFilters;
